// import external dependencies

import "jquery";

// Import everything from autoload
import "./autoload/_foundation.js";

// Import modules
import "./jquery.mask.min.js";
import "./modules/global";
import "./modules/scroll";
import "./modules/layouts-functions/header";
import "./modules/sliders/img-side-slider.js"; import "./modules/sliders/member-slider.js"; import "./modules/sliders/text-arrow-slider.js";

jQuery(document).ready(() => {});



// WEBPACK FOOTER //
// ./scripts/main.js